import { j as s } from "../../../jsx-runtime-B6kdoens.js";
import { a as c } from "../../../index-CROKJrb5.js";
import { c as n, f } from "../../../create-component-CBAeEoQ6.js";
const i = n(
  "FooterNavColumn",
  f(
    ({ as: o, children: r, className: t, ...e }, a) => {
      const m = o || "div";
      return /* @__PURE__ */ s.jsx(
        m,
        {
          ref: a,
          className: c("cur-flex cur-grow cur-flex-col cur-gap-3", t),
          ...e,
          children: r
        }
      );
    }
  )
);
export {
  i as FooterNavColumn
};
//# sourceMappingURL=index.js.map
